export interface Category {
  id: string;
  name: string;
  shortName: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: "star",
    name: "明星动态",
    shortName: "明星",
    icon: "ri-user-star-line",
    description: "追踪一线艺人最新行程、作品与生活动态，第一时间捕捉娱乐圈风向。",
  },
  {
    id: "social",
    name: "社会热点",
    shortName: "社会",
    icon: "ri-newspaper-line",
    description: "聚焦城市生活与社会新闻现场，记录那些值得被看见的真实故事。",
  },
  {
    id: "fun",
    name: "趣味短片",
    shortName: "趣味",
    icon: "ri-emotion-happy-line",
    description: "轻松一刻，收录让人会心一笑的日常短片与脑洞名场面。",
  },
  {
    id: "film",
    name: "影视资讯",
    shortName: "影视",
    icon: "ri-movie-line",
    description: "新片定档、预告解析与幕后花絮，带你提前进入光影世界。",
  },
  {
    id: "music",
    name: "音乐现场",
    shortName: "音乐",
    icon: "ri-music-2-line",
    description: "从音乐节到街头演出，收录最打动人的现场声音瞬间。",
  },
  {
    id: "game",
    name: "游戏电竞",
    shortName: "游戏",
    icon: "ri-gamepad-line",
    description: "赛事决胜时刻、新游上线实况与玩家的快乐与遗憾。",
  },
];